<template>
  <AppModalEdit
    :value="value"
    :loading="loading"
    :confirm-on-click-cancel="form.body > 0"
    @input="$emit('input', $event)"
    @clickExec="onSubmit"
    title="地点グループ一括登録"
    exec-button-text="一括登録"
  >
    <p>各行につき1つずつ地点グループ名を入力してください。</p>
    <v-textarea
      v-model="form.body"
      :placeholder="`地点グループ名1\n地点グループ名2`"
      :color="hasError ? 'red' : 'primary'"
      :background-color="hasError ? 'red' : undefined"
      :hide-details="!hasError"
      :error="hasError"
      :error-messages="
        hasError
          ? [`地点グループを登録できませんでした。もう一度お試しください。`]
          : []
      "
      outline
      height="60vh"
      class="bulkInputArea"
    />
  </AppModalEdit>
</template>

<script>
import { mapActions } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import BulkAddLocationGroupFormModel from '@/models/LocationGroup/BulkAddLocationGroupForm'

export default {
  name: 'LocationGroupModalBulkAdd',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    ownerProfileId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      form: new BulkAddLocationGroupFormModel({
        ownerProfileId: this.ownerProfileId,
      }),
      hasError: false,
    }
  },
  methods: {
    ...mapActions('pointGroupOperation', {
      getGroupList: 'GET_GROUP_LIST',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async onSubmit() {
      try {
        this.loading = true
        await this.form.save()
        this.showSnackbar({
          type: snackbarType.SUCCESS,
          message: '地点グループを一括登録しました',
        })
        this.$emit('save')
        this.close()
      } catch (e) {
        // エラーが起きた地点を残す
        this.form.body = e.errors
          .map(error => error.locationGroup.name)
          .join('\n')
        this.hasError = true
        throw e
      } finally {
        this.loading = false
      }
    },
    close() {
      this.getGroupList({ ownerProfileId: this.ownerProfileId })
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped lang="scss">
.bulkInputArea {
  ::v-deep .v-text-field__slot > textarea {
    margin-top: 0;
    font-size: 14px;
  }
}
</style>
